import React, { useState } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calendar, dark_close, MaleImage, popup_close } from '../../assets/images';
import { MultiSelect } from "react-multi-select-component";
import Select from 'antd/lib/select';
import { dsButtonDisabledPrimary, dsButtonDisabledSecondary, dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles';

const age_options = Array.from({ length: 101 }, (_, index) => `${index}`);

const gender_options = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Non-binary", value: "Non-binary" },
  { label: "Unspecified", value: "Unspecified" }
]

const packageForOptions = [
  { label: "Employee", value: "Employee" },
  { label: "Dependent", value: "Dependent" },
]

const statusOptions = [
  { label: "Completed", value: "Completed" },
  { label: "Upcoming", value: "Upcoming" },
]

const ohcStatusOptions = [
  { label: "In progress", value: "In progress" },
  { label: "Closed", value: "Closed" },
]

// The OHC log's own filters, from its API's filter_options: [key, heading, options key]
const OHC_FILTERS = [
  ['sites', 'SITE', 'sites'], ['visit_types', 'VISIT TYPE', 'visit_types'],
  ['health_issues', 'HEALTH ISSUE', 'health_issues'], ['employee_types', 'EMPLOYEE TYPE', 'employee_types'],
]
const asOptions = (list = []) => list.map((item) => (typeof item === 'string' ? { label: item, value: item } : item))

const packageTypeOptions = [
  { label: 'Standalone Package', value: 'Standalone' },
  { label: 'Split Package First Part', value: 'First Part' },
  { label: 'Split Package Intermediate', value: 'Intermediate' },
  { label: 'Split Package Last Part', value: 'Last Part' },
]

const resetButtonClass =
  'inline-flex h-10 items-center justify-center rounded-lg border border-gray-250 bg-gray-100 px-4 text-xs font-semibold leading-none shadow-sm transition';
const resetButtonEnabledClass = 'text-blue-600 hover:border-blue-600 hover:bg-gray-50';
const resetButtonDisabledClass = 'cursor-default text-gray-400 shadow-none';

const transform = (data) => {
  return data.map(item => {
    return {
      label: item,
      value: item
    }
  });
}

const ActivityLogFiltersModal = ({ filterParams, startDate, endDate, visible, onCancel, setFilterParams, clearFilters, changeDates, filterDates, packages = [], count = 0, applyFilter, benefit_type, ohcOptions = {} }) => {
  const isOhc = benefit_type === 'ohc';
  const showPackages = !['pharmacy', 'ohc'].includes(benefit_type);

  const package_option = packages.map((p) => {
    return {
      value: p.id,
      label: p.name
    }
  });
  const transformPackages = (data) => {
    return package_option.filter(option => data.includes(option.value));
  };
  const contractStartDate = new Date(moment(startDate, 'YYYY-MM-DD'));
  const contractEndDate = new Date(moment(endDate, 'YYYY-MM-DD'));
  const start_date = filterDates?.startDate ? new Date(moment(filterDates?.startDate, 'YYYY-MM-DD')) : contractStartDate;
  const end_date = filterDates?.endDate ? new Date(moment(filterDates?.endDate, 'YYYY-MM-DD')) : contractEndDate;
  const selectedPackages = filterParams.package_ids ? transformPackages(filterParams.package_ids) : [];
  const selectedAgeFrom = filterParams.age?.from ? filterParams.age?.from : undefined;
  const selectedAgeTo = filterParams.age?.to ? filterParams.age?.to : undefined;
  const selectedGender = filterParams?.genders ? transform(filterParams.genders) : [];
  const selectedPackageFor = filterParams?.package_for ? transform(filterParams.package_for) : [];
  const selectedStatus = filterParams?.status ? transform(filterParams.status) : [];
  const selectedPackageTypes = filterParams?.package_types ? transform(filterParams.package_types) : [];
  const [packageIds, setPackageIds] = useState(selectedPackages);
  const [ageFrom, setAgeFrom] = useState(selectedAgeFrom);
  const [ageTo, setAgeTo] = useState(selectedAgeTo);
  const [genders, setGenders] = useState(selectedGender);
  const [packageFor, setPackageFor] = useState(selectedPackageFor);
  const [status, setStatus] = useState(selectedStatus);
  const [packageTypes, setPackageTypes] = useState(selectedPackageTypes);
  const [ohcPicks, setOhcPicks] = useState(() => Object.fromEntries(OHC_FILTERS.map(([key, , optionsKey]) => [
    key, asOptions(ohcOptions[optionsKey]).filter((o) => (filterParams[key] || []).includes(o.value))])));

  const ohcHandler = (key) => (e) => {
    setOhcPicks((prev) => ({ ...prev, [key]: e }));
    if (e.length === 0) clearFilters(key);
    else setFilterParams(e.map((item) => item.value), key);
  };

  const initialState = !(selectedAgeFrom == undefined && selectedAgeTo == undefined);
  const isSelectedDateContractStartDate = start_date.getTime() === contractStartDate.getTime();
  const isSelectedDateContractEndDate = end_date.getTime() === contractEndDate.getTime();
  const initialDateState = (isSelectedDateContractStartDate && isSelectedDateContractEndDate);

  const packageHandler = (e) => {
    if (e.length == 0) {
      clearFilters('package_ids')
      setPackageIds(e);
    }
    else {
      setPackageIds(e);
      let values = e.map(item => item.value)
      setFilterParams(values, 'package_ids')
    }
  };

  const ageHandler = (e, type) => {
    if (type == 'from') {
      setAgeFrom(e);
      setFilterParams(e, 'age_from');
    }
    else if (type == 'to') {
      setAgeTo(e);
      setFilterParams(e, 'age_to')
    }
    else if (type == 'reset') {
      clearFilters('age')
      setAgeFrom()
      setAgeTo()
    }
  }

  const genderHandler = (e) => {
    if (e.length == 0) {
      clearFilters('genders')
      setGenders(e);
    }
    else {
      setGenders(e);
      let values = e.map(item => item.value)
      setFilterParams(values, 'genders')
    }
  };

  const packageForHandler = (e) => {
    if (e.length == 0) {
      clearFilters('package_for')
      setPackageFor(e);
    }
    else {
      setPackageFor(e);
      let values = e.map(item => item.value)
      setFilterParams(values, 'package_for')
    }
  };

  const statusHandler = (e) => {
    if (e.length == 0) {
      clearFilters('status')
      setStatus(e);
    }
    else {
      setStatus(e);
      let values = e.map(item => item.value)
      setFilterParams(values, 'status')
    }
  };

  const packageTypeHandler = (e) => {
    if (e.length === 0) {
      clearFilters('package_types');
      setPackageTypes([]);
    } else {
      setPackageTypes(e);
      const values = e.map((item) => item.value);
      setFilterParams(values, 'package_types');
    }
  };

  const crossBtnHandler = (e) => {
    clearBtnHandler(e);
    onCancel();
  }

  const clearBtnHandler = (e) => {
    setFilterParams(e, 'clear');
    setGenders([]);
    setPackageIds([]);
    setPackageFor([]);
    setAgeFrom();
    setAgeTo();
    setStatus([]);
    setPackageTypes([]);
    setOhcPicks({});
    clearFilters('package_types');
    changeDates(e, 'reset');
  };

  const customPackageValueRenderer = (selected, _options) => {
    if (selected.length) {
      if (selected.length >= 2)
        return `${sliceText(selected[0].label)} & ${selected.length - 1} more`
      else
        return sliceText(selected[0].label)
    }
  };

  const sliceText = (text) => {
    if (text.length > 62)
      return `${text.slice(0, 59)}...`
    else
      return `${text}`
  };

  const customGenderValueRenderer = (selected, _options) => {
    if (selected.length) {
      if (selected.length == 1)
        return selected[0].label
      else {
        let list = selected.map(item => item.label)
        return list.slice(0, -1).join(", ") + (list.length > 1 ? ", " : "") + list.slice(-1);
      }
    }
  };

  const customPackageForValueRenderer = (selected, _options) => {
    if (selected.length) {
      if (selected.length == 1)
        return `${selected[0].label}`
      else
        return `${selected[0].label}, ${selected[1].label}`
    }
  };

  const CustomItemRenderer = ({
    checked,
    option,
    onClick,
    disabled,
  }) => (
    <div className={`item-renderer ${disabled ? "disabled" : "font-heavy items-center"}`}
      style={{ display: 'flex', alignItems: 'center' }}>
      <div >
        <input
          type="checkbox"
          onChange={onClick}
          checked={checked}
          tabIndex={-1}
          disabled={disabled}
        />
      </div>
      <div>
        <span style={{ verticalAlign: 'middle', marginTop: '3px', display: 'flex', alignItems: 'center' }}>{option.label}</span></div>
    </div>
  );

  return (
    <div
      className={`absolute z-20 overflow-y-auto  ${visible ? '' : 'hidden'} mt-10 -ml-72`}
      aria-labelledby='modal-title'
      aria-modal='true'
      style={{ marginLeft: `${count > 0 ? '-15rem' : '-15.5rem'}` }}
    >
      <div className='flex items-end justify-center inset-0 text-center sm:block'>
        <div className='inline-block bg-white normal-case rounded-2xl border text-left shadow-md bg-blend-overlay'
          style={{ zIndex: 1000, width: '32.5rem', height: 'auto' }}
        >
          <div className="bg-white flex-col flex px-5 pb-5 pt-4">
            <div className='flex'>
              <div className='font-semibold text-lg text-gray-700 text-center items-center'>
                Filters
              </div>
              <img src={dark_close} alt='close-btn' className='absolute right-8 mt-2 text-center items-center cursor-pointer h-3 w-3' onClick={(e) => crossBtnHandler(e)} />
            </div>
            <div className='flex mt-4'>
              <div className='font-heavy text-center tracking-wider text-gray-300' style={{ marginRight: '7.7rem' }}>
                START DATE
              </div>
              <div className='font-heavy text-center tracking-wider text-gray-300'>
                END DATE
              </div>
            </div>
            <div className='flex mt-2'>
              <div className='flex bg-gray-100 -mt-1 items-center border-gray-200 border justify-center mr-4 rounded date-box' style={{ height: '2.45rem', width: '13rem' }}>
                <img src={calendar} style={{ width: 14 }} alt='calender' className=' ml-3 mr-2' />
                <DatePicker
                  onChange={(e) => changeDates(e, 'startDate')}
                  selected={start_date}
                  dateFormat="dd/MMM/yyyy"
                  isClearable={!isSelectedDateContractStartDate}
                  showYearDropdown
                  showMonthDropdown
                  className={'filter-date-range bg-gray-100 border-gray-200 cursor-pointer text-gray-600'}
                  minDate={contractStartDate}
                  maxDate={end_date}
                />
              </div>
              <div className='flex bg-gray-100 -mt-1 items-center border-gray-200 border justify-center mr-4 rounded date-box' style={{ height: '2.45rem', width: '13rem' }}>
                <img src={calendar} style={{ width: 14 }} alt='calender' className=' ml-3 mr-2' />
                <DatePicker
                  onChange={(e) => changeDates(e, 'endDate')}
                  selected={end_date}
                  dateFormat="dd/MMM/yyyy"
                  isClearable={!isSelectedDateContractEndDate}
                  showYearDropdown
                  showMonthDropdown
                  className={'filter-date-range bg-gray-100 cursor-pointer text-gray-600'}
                  minDate={start_date}
                  maxDate={contractEndDate}
                />
              </div>
              <button
                onClick={(e) => changeDates(e, 'reset')}
                className={`-mt-1 ${resetButtonClass} ${initialDateState ? resetButtonDisabledClass : resetButtonEnabledClass}`}
                disabled={initialDateState}
              >
                Reset
              </button>
            </div>
            {showPackages && <>
              <div className='font-heavy mt-5 mb-1 tracking-wider text-gray-300'>
                PACKAGE NAME
              </div>
              <div className='font-heavy font-proxima-nova cursor-pointer'>
                <MultiSelect
                  options={package_option}
                  value={packageIds}
                  onChange={(e) => packageHandler(e)}
                  labelledBy="Select"
                  valueRenderer={customPackageValueRenderer}
                  ItemRenderer={CustomItemRenderer}
                  overrideStrings={{ "selectSomeItems": "Select" }}
                />
              </div></>}
            {isOhc && OHC_FILTERS.map(([key, heading, optionsKey]) => (
              <React.Fragment key={key}>
                <div className='font-heavy mt-5 mb-1 tracking-wider text-gray-300'>{heading}</div>
                <div className='font-heavy font-proxima-nova text-gray-600'>
                  <MultiSelect
                    options={asOptions(ohcOptions[optionsKey])}
                    value={ohcPicks[key] || []}
                    onChange={ohcHandler(key)}
                    labelledBy={heading}
                    hasSelectAll={false}
                    valueRenderer={customGenderValueRenderer}
                    ItemRenderer={CustomItemRenderer}
                    overrideStrings={{ "selectSomeItems": "Select" }}
                  />
                </div>
              </React.Fragment>
            ))}
            <div className='flex mt-5'>
              <div className='font-heavy text-center tracking-wider text-gray-300' style={{ marginRight: '8rem' }}>
                START AGE
              </div>
              <div className='font-heavy text-center tracking-wider text-gray-300'>
                END AGE
              </div>
            </div>
            <div className='flex mt-1'>
              <div className='font-heavy font-proxima-nova text-gray-600 bg-gray-100' style={{ width: '13rem', marginRight: '1rem' }}>
                <Select
                  value={ageFrom}
                  className="rounded"
                  placeholder="Select"
                  onChange={(e) => ageHandler(e, 'from')}
                  style={{ width: '100%', paddingLeft: '-2px', backgroundColor: '#F9FAFB' }}
                  size='middle'
                  popupClassName='text-gray-300' >
                  {
                    age_options.map((e) => {
                      return (<Option key={e} value={e}>{e}</Option>)
                    })
                  }
                </Select>
              </div>
              <div className='font-heavy font-proxima-nova text-gray-600' style={{ width: '13rem', marginRight: '1rem' }}>
                <Select
                  showSearch
                  value={ageTo}
                  className="rounded"
                  placeholder="Select"
                  onChange={(e) => ageHandler(e, 'to')}
                  style={{ width: '100%', paddingLeft: '-2px', backgroundColor: '#F9FAFB' }}
                  size='middle'
                  popupClassName='text-gray-300'>
                  {
                    age_options.map((e) => {
                      return (<Option key={e} value={e}>{e}</Option>)
                    })
                  }
                </Select>
              </div>
              <button
                onClick={(e) => ageHandler(e, 'reset')}
                className={`w-16 h-10 block rounded border bg-gray-100 text-base rounded font-semibold  ${initialState ? 'hover:border-blue-500 text-blue-600' : 'text-gray-300 cursor-default'}`} style={{ height: '2.45rem' }} >
                Reset
              </button>
            </div>
            <div className='font-heavy mt-5 mb-1 tracking-wider text-gray-300'>
              GENDER
            </div>
            <div className='font-heavy font-proxima-nova text-gray-600' >
              <MultiSelect
                options={gender_options}
                value={genders}
                onChange={(e) => genderHandler(e)}
                labelledBy="Select"
                hasSelectAll={false}
                disableSearch={true}
                valueRenderer={customGenderValueRenderer}
                ItemRenderer={CustomItemRenderer}
                overrideStrings={{ "selectSomeItems": "Select" }}
              />
            </div>
            {showPackages && <>
              <div className='font-heavy mt-5 mb-1 tracking-wider text-gray-300'>
                PACKAGE FOR
              </div>
              <div className='font-heavy font-proxima-nova text-gray-600'>
                <MultiSelect
                  options={packageForOptions}
                  value={packageFor}
                  onChange={(e) => packageForHandler(e)}
                  labelledBy="Select"
                  disableSearch={true}
                  hasSelectAll={false}
                  valueRenderer={customPackageForValueRenderer}
                  ItemRenderer={CustomItemRenderer}
                  overrideStrings={{ "selectSomeItems": "Select" }}
                />
              </div>
            </>}
            <div className='font-heavy mt-5 mb-1 tracking-wider text-gray-300'>
              STATUS
            </div>
            <div className='font-heavy font-proxima-nova text-gray-600'>
              <MultiSelect
                options={isOhc ? ohcStatusOptions : statusOptions}
                value={status}
                onChange={(e) => statusHandler(e)}
                labelledBy="Select"
                disableSearch={true}
                hasSelectAll={false}
                valueRenderer={customPackageForValueRenderer}
                ItemRenderer={CustomItemRenderer}
                overrideStrings={{ "selectSomeItems": "Select" }}
              />
            </div>
            {showPackages && <>
              <div className='font-heavy mt-5 mb-1 tracking-wider text-gray-300'>
                PACKAGE TYPE
              </div>
              <div className='font-heavy font-proxima-nova text-gray-600'>
                <MultiSelect
                  options={packageTypeOptions}
                  value={packageTypes}
                  onChange={packageTypeHandler}
                  labelledBy="Select"
                  disableSearch={true}
                  hasSelectAll={false}
                  valueRenderer={customPackageForValueRenderer}
                  ItemRenderer={CustomItemRenderer}
                  overrideStrings={{ "selectSomeItems": "Select" }}
                />
              </div>
            </>}
          </div>
          <div className="flex justify-end bg-gray-100 py-5 pr-5" >
            <button
              type='submit'
              onClick={(e) => clearBtnHandler(e)}
              className={joinButtonClasses(dsButtonSecondary, 'mr-4 h-10 px-8', count === 0 && dsButtonDisabledSecondary)}
              disabled={count == 0}
            >
              Clear filters
            </button>
            <button
              type='submit'
              disabled={count == 0}
              onClick={applyFilter}
              className={joinButtonClasses(dsButtonPrimary, 'h-10 px-5', count === 0 && dsButtonDisabledPrimary)}
            >
              Apply filters
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActivityLogFiltersModal
